import { shallowEqual, useSelector } from 'react-redux';
import { getSpeedType } from '../ducks';

export const useGetSpeedType = () => ({
  speedType: useSelector(getSpeedType, shallowEqual),
});
